// MACHINERY V2 (Stroje) — dialog host for the fleet surface (M2.2).
//
// >>> THE ONE SANCTIONED MUI IMPORT SITE IN v2. <<<
//
// Ticket §5: "The kebab actions (QR / Vyradiť) are listed in the designer but
// their dialogs are NOT redesigned — v2 reuses the existing dialogs (they open
// over the v2 surface) until separately scheduled." Those dialogs are MUI
// components, so v2 has to mount them somewhere. Confining every one of them to
// THIS file means the v2 stack rule ("no MUI in the v2 chrome") still holds
// everywhere a v2 SURFACE is drawn, and the day each dialog is redesigned its
// import disappears from exactly one place.
//
// Nothing here is styled, wrapped or re-skinned — the dialogs render exactly as
// they do on the live grid. This is a mount point, not a component.
//
// DIALOG STATE LIVES IN THE PAGE (FleetV1Page), not here: the same dialog is
// opened from a card kebab and from the toolbar, so a single owner keeps the
// open/close pairs honest.
import React from "react";

import { Machine } from "../../models/models";
import AssignGroupDialog from "../../components/AssignGroupDialog";
import DecommissionDialog from "../../components/DecommissionDialog";
import MachineDialog from "../../components/MachineDialog";
import MachineEditDialog from "../../components/MachineEditDialog";
import MachineQRCodeDialog from "../../components/MachineQRCodeDialog";
import ManageGroupsDialog from "../../components/ManageGroupsDialog";

export interface FleetDialogsProps {
  /** The slice-selected machine — MachineDialog + QR read it from there. */
  selectedMachine?: Machine;
  addOpen: boolean;
  onAddClose: () => void;
  onCreated: (id?: string) => void;
  qrOpen: boolean;
  onQrClose: () => void;
  manageGroupsOpen: boolean;
  onManageGroupsClose: () => void;
  assignGroupOpen: boolean;
  assignGroupMachine: Machine | null;
  onAssignGroupClose: () => void;
  onAssigned: () => void;
  editMachine: Machine | null;
  onEditClose: () => void;
  onEditSaved: () => void;
  decommissionMachine: Machine | null;
  onDecommissionClose: () => void;
  onDecommissioned: () => void;
}

const FleetDialogs: React.FC<FleetDialogsProps> = ({
  selectedMachine, addOpen, onAddClose, onCreated, qrOpen, onQrClose,
  manageGroupsOpen, onManageGroupsClose, assignGroupOpen, assignGroupMachine,
  onAssignGroupClose, onAssigned, editMachine, onEditClose, onEditSaved,
  decommissionMachine, onDecommissionClose, onDecommissioned,
}) => (
  <>
    {addOpen && (
      <MachineDialog
        key={`machine-dialog-${addOpen}`}
        open={addOpen}
        onClose={onAddClose}
        machine={selectedMachine}
        isNew={!selectedMachine}
        onCreated={onCreated}
      />
    )}

    {!!selectedMachine && (
      <MachineQRCodeDialog
        key={`qr-code-dialog-${qrOpen}`}
        open={qrOpen}
        onClose={onQrClose}
        machine={selectedMachine}
      />
    )}

    <ManageGroupsDialog open={manageGroupsOpen} onClose={onManageGroupsClose} />

    <AssignGroupDialog
      open={assignGroupOpen}
      onClose={onAssignGroupClose}
      machine={assignGroupMachine}
      onAssigned={onAssigned}
    />

    {!!editMachine && (
      <MachineEditDialog
        open
        machine={editMachine}
        onClose={onEditClose}
        onSaved={onEditSaved}
      />
    )}

    <DecommissionDialog
      open={!!decommissionMachine}
      machine={decommissionMachine}
      onClose={onDecommissionClose}
      onDecommissioned={onDecommissioned}
    />
  </>
);

export default FleetDialogs;
